import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '../context/ThemeContext';

const PressPage = () => {
  const { theme } = useTheme();
  return (
    <>
      <Helmet><title>Press | BookMyAudition</title></Helmet>
      <div className="press-page" style={{ minHeight: '70vh', padding: '60px 0', backgroundColor: theme === 'dark' ? '#0a0a14' : '#f8fafc', color: theme === 'dark' ? '#f8fafc' : '#111' }}>
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8}>
              <h1 className="fw-bold mb-4">Press Room</h1>
              <p className="mb-5">Download brand assets and read our latest press releases.</p>
              <div className="coming-soon-box p-5 rounded-4 shadow-sm" style={{ backgroundColor: theme === 'dark' ? '#111116' : '#fff', border: `1px solid ${theme === 'dark' ? '#1f1f2e' : '#eaeaea'}` }}>
                <div className="d-inline-block mb-3 px-3 py-1 rounded-pill" style={{ backgroundColor: 'rgba(139, 92, 246, 0.1)', color: '#8b5cf6', fontSize: '0.85rem', fontWeight: '600' }}>MEDIA KIT</div>
                <h3>Coming Soon</h3>
                <p className="text-muted">We are preparing our official press kit and brand guidelines. Stay tuned!</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
export default PressPage;